import en from './en';
import ta from './ta';

const locales = { en, ta };

export const getLocale = (lang) => locales[lang] || locales.en;

export const availableLanguages = [
  { code: 'en', label: 'English' },
  { code: 'ta', label: 'தமிழ்' },
];

export default locales;
